import { render } from "./Resultaten.vue?vue&type=template&id=fa32f910&scoped=true"
import script from "./Resultaten.vue?vue&type=script&lang=js"
export * from "./Resultaten.vue?vue&type=script&lang=js"

import "./Resultaten.vue?vue&type=style&index=0&id=fa32f910&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa32f910"]])

export default __exports__